<template>
    <div class="full_mark_box" v-show="isShow_feedbackpop">
		<div id="feedbackpop_wrap">
			<div class="feedbackpop_wrap_top">
				<span class="l_title_wrap"  >意见反馈</span>
				<span class="l_title_btn"  @click="closefeedbackpop" title="点击关闭"><i class="el-icon-close"></i></span>
			</div>
			<div class="feedbackpop_wrap_main">
				<div class="maincontent">
					<textarea placeholder="请输入您对平台的意见或建议" v-model="content">
						
					</textarea>
					<span class="phone_cue" style="float: left;"></span>
				</div>
				<div class="contact_way">
					<input type="text" placeholder="请留下您的联系方式，方便我们联系您（必填）" v-model="contactWay"/>
				</div>
				<div class="submit_reset_number" @click="submitfeedbackpop">
					提交
				</div>
			</div>
		</div> 
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isShow_feedbackpop:false,
				contactWay:'',		//联系方式
				content:'',			//反馈的内容
			}
		},
		methods: {
			// 打开意见反馈弹窗
			openfeedbackpop() {
				if(sessionStorage.getItem('phone') != null){
					this.contactWay = sessionStorage.getItem('phone');
				}
				this.isShow_feedbackpop = true;
			},
			//关闭提交问题弹窗
			closefeedbackpop() {
				this.isShow_feedbackpop = false;
			},
			submitfeedbackpop() {
				let _this=this;
				//提交反馈
				if(this.contactWay == '' || this.content == ''){
//					alert('请输入反馈内容和联系方式');
					this.$message({
								message: '请输入反馈内容和联系方式',
								type: 'warning',
								customClass: 'message-warning',
							});
					return;
				}else{
					this.$http.get(
					_this.apiUrl+'index.php?m=Api&c=user&a=feedbackAdd',
					{
						params: {  
							"contact":this.contactWay,
							'content':this.content,
							'phone':sessionStorage.getItem('phone')
						}  
					}
					).then(response => {
	
						//进行数据验证
						if(response.body.status != 1){
							
							//显示错误页面
//							alert('请求错误');
							this.$router.push('/404')
							return;
						}
//						alert('提交成功');
						this.$message({
								message: '提交成功',
								type: 'warning',
								customClass: 'message-warning',
							});
						this.isShow_feedbackpop = false;
	
				}, response => {
//					console.log("error");
				});
				}
				
			}
		}
	}
</script>

<style>
		.full_mark_box{
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 999;
		background: rgba(0,0,0,.5);
	}
	#feedbackpop_wrap,#reset_password_wrap{
		background: white;
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
		width: 514px;
		height: 350px;
		border-radius: 5px;
	}
	#feedbackpop_wrap .feedbackpop_wrap_top{
		border-radius: 5px 5px 0 0;
		padding: 0 20px;
		height: 40px;
		background: #F3F7F9;
		width: 474px;
	}
	#feedbackpop_wrap .feedbackpop_wrap_main {
		width:460px ;
		margin: 0 auto;
		margin-top: 30px;
	}
	#feedbackpop_wrap .feedbackpop_wrap_main .maincontent{
		width:460px ;
		height: 135px;
		font-size: 14px;
	}
	#feedbackpop_wrap .l_title_wrap{
		float: left;
		display: block;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: 700;
		color: #5E5F5F;
	}
	#feedbackpop_wrap .l_title_btn{
		float: right;
		display: block;
		height: 40px;
		line-height: 40px;
		font-size: 24px;
		color: #AAAAAA;
		cursor: pointer;
	}
	.feedbackpop_wrap_main .maincontent>textarea{
		border-radius: 6px;
		width: 460px;
		height: 130px;
		border: 1px solid #F2F2F2;
		text-indent: 1em;
		text-align: left;
		line-height: 24px;
		font-size: 16px;
		resize: none;
		font-weight: 700;
	}
	.feedbackpop_wrap_main .maincontent span{
		width: 460px;
		height: 20px;
		font-size: 16px;
		line-height: 20px;
		color: red;
	}
	.feedbackpop_wrap_main .contact_way{
		height: 67px;
		width: 460px;
		line-height: 0;
		
	}
	.feedbackpop_wrap_main .contact_way>input{
		height: 40px;
		width: 460px;
		line-height: 40px;
		text-indent: 1.5em;
		border-radius: 6px;
        border: 1px solid #F2F2F2;
        margin-top: -20px;
        
	}
	#feedbackpop_wrap .submit_reset_number{
		display: block;
		height: 36px;
		line-height: 36px;
		background: #076bf2;
		/*background: -webkit-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: -o-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: -moz-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: linear-gradient(30deg, #65d2ff , #076bf2);*/
		border-radius:18px;
		font-size: 16px;
		width: 160px;
		margin: 20px auto;
		color: white;
		margin-top: 10px;
		cursor: pointer;
	}
	.phone_cue{
		border: 0 solid #EBEBEB;
	}
</style>


// WEBPACK FOOTER //
// src/messageBox/feedbackpop.vue